import React from 'react';
import Title from './Title';

interface SubTitleProps {
  text?: string;
}

const SubTitle = function ({ text = undefined }: SubTitleProps) {
  if (!text) return null;
  return <Title level={3}>{text}</Title>;
};

export default SubTitle;
